import React, { useMemo } from "react";

import { color, scaleLinear } from "d3";

import { HexColor } from "@mapmycustomers/shared/types/AnyColor";

import styles from "./Theme.module.scss";

interface Props {
  blockCount?: number;
  endColor: HexColor;
  startColor: HexColor;
}

const Theme: React.FC<Props> = ({ blockCount = 5, endColor, startColor }) => {
  const colorFn = useMemo(
    () => scaleLinear([0, blockCount - 1], [startColor, endColor]),
    [blockCount, endColor, startColor]
  );

  return (
    <div className={styles.container}>
      {Array.from({ length: blockCount }, (_, index) => (
        <span
          className={styles.box}
          key={index}
          style={{ backgroundColor: color(colorFn(index))?.formatHex() }}
        />
      ))}
    </div>
  );
};

export default Theme;
